import { useState } from 'react'
import { Send } from 'lucide-react'
import { demoToast } from '@/shared/lib/demo/demo-toast'
import { Button } from '@/shared/components/ui/button'
import { Input } from '@/shared/components/ui/input'

interface Props {
  chips: string[]
  agentName: string
}

export function AssistantInputBar({ chips, agentName }: Props) {
  const [value, setValue] = useState('')

  const handleSend = () => {
    if (value.trim()) {
      demoToast()
      setValue('')
    }
  }

  return (
    <div className="shrink-0 border-t">
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-1.5 px-3 pt-2.5 pb-1">
          {chips.map((chip) => (
            <button
              key={chip}
              onClick={() => setValue(chip)}
              className="rounded-full border bg-background px-2.5 py-0.5 text-[10px] text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
            >
              {chip}
            </button>
          ))}
        </div>
      )}
      <div className="flex items-center gap-2 px-3 py-2.5">
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSend()}
          placeholder={`Ask ${agentName}…`}
          className="h-8 text-xs"
        />
        <Button size="icon" variant="ghost" className="h-8 w-8 shrink-0" onClick={handleSend}>
          <Send className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  )
}
